import {Component, EventEmitter, Input, Output} from "@angular/core";
import {PaginatorState} from "primeng/paginator";
import {PageInfo} from "../../model/response/page-info.model";

@Component({
    selector: 'app-paginator',
    templateUrl: './paginator.component.html',
    standalone: false
})
export class PaginatorComponent {

  @Input('paginationDetails') paginationDetails: PageInfo
  @Output('pageChangeEvent') pageChangeEmitter = new EventEmitter<PaginatorState>()

  constructor() {
  }

  onPageChange($event: PaginatorState) {
    this.pageChangeEmitter.emit($event)
  }
}
